<template>
    <div class="about">
<!--      <first-Component></first-Component>-->
      <img class="banner animated fadeIn" src="../assets/about/ban.png" alt="" id="d1">
      <div class="link animated fadeInLeft">
        <div class="main">
          <span class="title">{{$t('about.link[0]')}}</span>
          <span>{{$t('about.link[1]')}}</span>
        </div>
      </div>
      <div class="allInfo wow fadeInUp">
        <p class="t">{{$t('about.titleList[0]')}}</p>
        <span class="la"></span>
        <div class="oneInfo">
          <div class="leftInfo" style="font-family: light2">
            <p>{{$t('about.allCon[0]')}}{{$t('about.allCon[1]')}}
            <br>
              {{$t('about.allCon[2]')}}
            {{$t('about.allCon[3]')}}
              {{$t('about.allCon[4]')}}
            <br>
              {{$t('about.allCon[5]')}}<br>
              {{$t('about.allCon[6]')}}
            </p>
          </div>
          <img src="../assets/about/righ.jpg" alt="">
        </div>
      </div>
      <div class="allInfo2 wow fadeInUp">
      <div class="twoInfo">
        <img src="../assets/about/l.jpg" alt="">
        <div  class="right">
          <p class="tt">{{$t('about.titleList[1]')}}</p>
       <span></span>
          <p class="m" style="font-family: light2">
           {{$t('about.historyCon[0]')}}<br>
            {{$t('about.historyCon[1]')}}<br>
            {{$t('about.historyCon[2]')}}<br>
            {{$t('about.historyCon[3]')}}<br>
            {{$t('about.historyCon[4]')}}
          </p>
        </div>
      </div>
      </div>
      <p class="t wow fadeInUp">{{$t('about.titleList[2]')}}</p>
      <span class="la wow fadeInUp"></span>
      <p class="st wow fadeInUp" style="font-family: light2;text-transform: capitalize">{{$t('about.syCon')}}</p>
      <div class="five wow fadeInUp">
        <img src="../assets/about/big.png" alt="" style="width:100%;object-fit: cover">
<!--        <div class="it" v-for="(item,index) in cList" :key="index" style="cursor: pointer">-->
<!--          <img :src="item.img" alt="">-->
<!--          <p style="font-family: light2">{{item.title}}</p>-->
<!--        </div>-->
      </div>
      <div class="print wow fadeInUp">
      <div class="leftI">
        <p class="t">{{$t('about.titleList[3]')}}</p>
        <span class="la"></span>
        <p class="c" style="font-family: light2">
         {{$t('about.carCon[0]')}}<br>
          {{$t('about.carCon[1]')}}
        </p>
      </div>
        <img class="rightImg" src="../assets/about/g.jpg" alt="">
        <img class="fI" src="../assets/about/bottom.jpg" alt="">


      </div>

      <div class="video wow fadeInUp">
        <video src="https://www.sansg.com/video/shuaifuyinshua.mp4"  controls></video>
        <video src="https://www.sansg.com/video/shuaifucaijian.mp4"  controls></video>
      </div>


      <p class="t t2 wow fadeInUp">{{$t('about.titleList[4]')}}</p>
      <div class="five five2 wow fadeInUp">
      <div class="it2" v-for="(item,index) in imgList" :key="index">
        <img :src="item" alt="">
      </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import firstComponent from  "./first"
  import footComponent from "./foot"
  import BtnComponent from "./btn"
  import Scrollbar from 'smooth-scrollbar';
    export default {
        name: "about",
      data(){
          return{
            lang:'',
            imgList:[
              require("../assets/sgs.png"),
              require("../assets/iso.png"),
              require("../assets/isoO.png"),
              require("../assets/bsci.png"),
              require("../assets/oh.png"),
              require("../assets/1.png"),
              require("../assets/2.png"),
              require("../assets/3.png"),
              require("../assets/4.png"),
              require("../assets/5.png")
            ],
            cList:[
              {img:require('../assets/about/img1.jpg'),title:'Lab1'},
              {img:require('../assets/about/img2.jpg'),title:'Lab2'},
              {img:require('../assets/about/img3.jpg'),title:'Lab3'},
              {img:require('../assets/about/img4.jpg'),title:'Lab4'},
              {img:require('../assets/about/img5.jpg'),title:'Lab5'},
            ],
            cList2:[
              {img:require('../assets/about/img1.jpg'),title:'实验室1 '},
              {img:require('../assets/about/img2.jpg'),title:'实验室1'},
              {img:require('../assets/about/img3.jpg'),title:'实验室1'},
              {img:require('../assets/about/img4.jpg'),title:'实验室1'},
              {img:require('../assets/about/img5.jpg'),title:'实验室1'},
            ]
          }
      },
      mounted(){
          this.lang= this.$i18n.locale
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        // scrollbar.scrollTo(0,0)
        if(this.$i18n.locale==='zh-CN'){
          this.cList=this.cList2
        }else{
          this.cList=this.cList
        }
      },
      components:{firstComponent,footComponent,BtnComponent},
      methods:{
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
      }
    }
</script>

<style scoped>
.about{
  width:100%;
}
.banner{
  width:100%;
  display: block;
}
.link{
  width:100%;
  padding: 30px 0;
  border-bottom: 1px solid rgba(250, 250, 250, 1);
}
.link .main{
  width:1280px;
  margin: 0 auto;
  text-align: left;
}
.link .main span{
  color:#C9382C;
  text-transform: uppercase;
}
.link .main .title{
  color:black;
}
  .allInfo{
    width:1280px;
    margin: 0 auto;
    padding-bottom: 60px;
  }
.t{
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  transition: all 2s;
  margin-top: 60px;
  margin-block-end: 0em;
  text-transform: uppercase;
}
.la{
  width:35px;
  height:3px;
  margin: 0 auto;
  background-color: #C9382C;
  display: inline-block;
}
.t:hover{
  color:#C9382C;
}
  .oneInfo{
    width:100%;
    display: flex;
    flex-direction: row;
    margin-top: 60px;
  }
  .oneInfo .leftInfo{
    text-align: left;
  }
.oneInfo .leftInfo p{
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
}
.oneInfo .leftInfo p span{
  color:#C9382C;;
}
  .oneInfo img{
    width:100%;
    height:100%;
    padding-left: 5%;
    padding-top: 80px;
    transition: all 2s;
    transform: scale(1.2);
    cursor: pointer;
  }
  .allInfo2{
    width:100%;
    background-color: #F1F4FB;
  }
  .twoInfo{
    width:1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding: 60px 0;
  }
  .twoInfo img{
    transition: all 2s;
  }
  .twoInfo img:hover{
    transform: scale(1.05);
  }
  .right{
    text-align: center;
    padding-left: 5%;
  }
  .tt{
    font-size: 25px;
    font-weight: bold;
    margin-block-end: 0em;
    position: relative;
  }
  .right span{
    display: inline-block;
    height:2px;
    width:35px;
    background-color: #C9382C;
  }
  .right .m{
    line-height: 50px;
    margin-top: 60px;
  }
  .st{
    margin-top: 40px;
  }
  .five{
    width:1280px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .it{
    overflow: hidden;
    width:18%;
    margin-bottom: 30px;
  }
  .it img{
    transition: all 2s;
    max-width: 80%;
    object-fit: contain;
  }
  .it p{
    transition: all 2s;
  }
  .it:hover img{
    transform: scale(1.05);
  }
  .it:hover p{
    color:#C9382C;
  }
  .five2{
    margin-top: 40px;
    padding-bottom: 80px;
  }
  .it2 img{
    transition: all 2s;
    max-width: 80%;
    object-fit: contain;
  }
  .it2 img:hover{
    transform: scale(1.05);
  }
  .five2 .it2{
    border: 1px solid #DBDBDB;
    width:18%;
    padding-top: 10px;
    margin-bottom: 30px;
  }
  .print{
    width:1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    position: relative;
  }
  .print .fI{
    position: absolute;
   top:70%;
    left:20%;
  }
  .print .leftI{
    text-align: left;
    width:50%;
  }
  .print .leftI  .t{
    text-align: center;
    position: relative;
  }
.print .leftI  .la{
margin-left: 45%;
}

.print .leftI .c{
  line-height: 50px;
  margin-top: 40px;
  text-align: center;
}
.rightImg,.fI{
  transition: all 2s;
}
.rightImg:hover{
  transform: scale(1.05);
}
.fI:hover{
  transform: scale(1.05);
}
.print .rightImg{
  margin-top: 60px;
}
  .t2{
  margin-top: -60px;
  }
.video{
  width:1280px;
  margin: 200px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
  video{
    height:400px;
    width:560px;
  }
  video:focus{
    outline: none;
  }
@media screen and (max-width:450px){
  .banner{
    height:100vh;
    object-fit: cover;
  }
  .about{
    overflow: hidden;
  }
  .link .main,.allInfo{
    width:90%;
    margin-left: 5%;
  }
  .oneInfo{
    display: flex;
    flex-direction: column;
  }
  .oneInfo .leftInfo p{
    font-size: 15px;
  }
  .t{
    font-size: 20px;
  }
  .oneInfo img{
    padding-left: 0;
  }
  .twoInfo{
    width:100%;
    display: flex;
    flex-direction: column;
  }
  .twoInfo img{
    width:100%;
    object-fit: cover;
  }
  .st{
    width:90%;
    margin-left: 5%;
    font-size: 14px;
    line-height: 30px;
  }
  .five{
    width:100%;
  }
  .print{
    width:100%;
    flex-direction: column;
  }
  .print .leftI{
    width:100%;
  }
  .print .fI{
    left:0;
    width:100%;
    object-fit: cover;
  }
  .video{
    width:100%;
    flex-direction: column;
 margin-top: 50px;
  }
  video{
    width:100%;
  }
  .five2{
    width:90%;
    margin-left: 5%;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
  }
  .five2 .it2{
    width:100%;
    margin-top: 30px;
  }
  .it2 img{
    object-fit: cover;
  }
  .right{
    width:90%;
    padding-left: 0;
    margin-left: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue